var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 14C1.51667 14 1.02083 13.7958 0.6125 13.3875C0.204167 12.9792 0 12.4833 0 11.9V2.1C0 1.51667 0.204167 1.02083 0.6125 0.6125C1.02083 0.204167 1.51667 0 2.1 0H11.9C12.4833 0 12.9792 0.204167 13.3875 0.6125C13.7958 1.02083 14 1.51667 14 2.1V11.9C14 12.4833 13.7958 12.9792 13.3875 13.3875C12.9792 13.7958 12.4833 14 11.9 14H2.1ZM2.1 12.6H11.9C12.0983 12.6 12.2645 12.5328 12.3984 12.3984C12.5328 12.2645 12.6 12.0983 12.6 11.9V2.1C12.6 1.90167 12.5328 1.7353 12.3984 1.6009C12.2645 1.46697 12.0983 1.4 11.9 1.4H2.1C1.90167 1.4 1.7353 1.46697 1.6009 1.6009C1.46697 1.7353 1.4 1.90167 1.4 2.1V11.9C1.4 12.0983 1.46697 12.2645 1.6009 12.3984C1.7353 12.5328 1.90167 12.6 2.1 12.6ZM2.8 11.2L5.6 8.4L6.86 9.6425L8.4 7.7L11.2 11.2H2.8ZM4.2 5.6C3.815 5.6 3.48553 5.4628 3.2116 5.1884C2.9372 4.91447 2.8 4.585 2.8 4.2C2.8 3.815 2.9372 3.48553 3.2116 3.2116C3.48553 2.9372 3.815 2.8 4.2 2.8C4.585 2.8 4.9147 2.9372 5.1891 3.2116C5.46303 3.48553 5.6 3.815 5.6 4.2C5.6 4.585 5.46303 4.91447 5.1891 5.1884C4.9147 5.4628 4.585 5.6 4.2 5.6Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.3bbe6141a6e80607e60dbd094573acae.svg";
export { ForwardRef as ReactComponent };